import React from "react";

const CheckMarkIcon = ({ width = "auto", height = "auto", style = {} }) =>
    <svg role="img" viewBox="0 0 1080 821" style={{ ...style, width: width, height: height }}>
        <title>Check mark icon</title>
        <g transform="matrix(1,0,0,1,-1.13687e-13,-0.0272483)">
            <path d="M0,475.21L85.852,389.357L345.323,648.826L994.148,0L1080,85.852L345.323,820.527L0,475.21Z" />
        </g>
    </svg>;

export default CheckMarkIcon;
